export default __webpack_public_path__ + "static/media/candidateListEmpty.2f46c587.svg";